const passThrough = (rawData, customers) => rawData.map(row => ({...row, item_id: row.uuid}));

const taAdminDataEnricher = (rawData, customers) => {
    if (customers === undefined) return rawData.map(row => ({...row, item_id: row.uuid}));

    const validateUserToCustomerMapping = (userData, customerData) => {
        if (userData.customer === customerData.value) return true;
        return userData.customer === null && customerData.value === "tapeark";

    };

    const processedData = [];

    rawData.forEach(userData => {
        const customer = customers.find(customer => validateUserToCustomerMapping(userData, customer));
        processedData.push({
            ...userData,
            item_id: userData.uuid,
            company: customer ? customer.label : "N/A"
        });
    });

    return processedData;
};

export const variantUsersDataProcessorFNMap = {
    "CustomerUsers": passThrough,
    "AllUsers": taAdminDataEnricher
};